import '@mdi/font/css/materialdesignicons.css'
import Vue from 'vue'
import Vuetify from 'vuetify/lib'
import zhHans from 'vuetify/es5/locale/zh-Hans'

Vue.use(Vuetify)

export default new Vuetify({
  theme: {
    dark: true,
    // [guanxing patch] M-SW12 两主界面 UI 统一 → M-SW24 极简单色化：灰阶色板。
    // secondary 换近黑灰——底栏三处菜单 v-list / view-settings 与 share 对话框
    // v-card class="secondary" 换色全局生效（原底栏 tmenubt 地点按钮已随
    // M-SW46 下线）；
    // primary 对齐 token 强调白（--gx-blue 现为 #ffffff）。
    themes: {
      dark: {
        primary: '#ffffff',
        secondary: '#1a1a1c'
      }
    }
  },
  lang: {
    current: 'zh-Hans',
    locales: { 'zh-Hans': zhHans }
  }
})
